import { sendXOSMessage } from '../helper'
import { IMQTTRes } from '../type'

type TGetAlbumFromParams = {
  platform: string // 'pc'|'an'|'ios' "访问来源" 
  limit: number  // 页数
  page_token: string // 偏移
}

type TGetAlbumFromRes = {
  config: {
    all: string
    paths: TGetAlbumFromPathItem[]
  }
  page_token: string // 偏移
}

export interface TGetAlbumFromPathItem {
  created_at: string
  path: string
  path_id: string
  disk_name: string
}

export function getAlbumFrom (params: TGetAlbumFromParams) {
  return sendXOSMessage<TGetAlbumFromRes>('get_album_from', params).then((data: IMQTTRes<TGetAlbumFromRes>) => {
    console.log('getAlbumFrom', data)
    if (data.ret !== 0) {
      throw new Error(`错误码：${data?.ret}`)
    }
    const { all, paths } = data.result.config
    const isScrapeAll = all === '1'
    const isScrape = isScrapeAll || paths?.length > 0
    const list = paths || []
    return { list, isScrape, isScrapeAll }
  })
}

export function deleteAlbumFrom (pathIds: string[]) {
  const params = { platform: 'pc', path_ids: pathIds }
  return sendXOSMessage<IMQTTRes<TGetAlbumFromRes>>('del_album_from', params).then(data => {
    console.log('deleteAlbumFrom', data)
    return data
  })
}

export function addAlbumFrom (params: { paths: Array<Omit<TGetAlbumFromPathItem, 'path_id'>> }) {
  const { paths } = params
  return sendXOSMessage<TGetAlbumFromRes>('set_album_from', {
    platform: 'pc', config: { all: '0', paths },
  }).then(response => {
    console.log('addAlbumFrom', response)
    return response
  })
}

export function updateAlbumFromAll (isAll: boolean) {
  return sendXOSMessage<TGetAlbumFromRes>('set_album_from', {
    platform: 'pc', config: { all: isAll ? '1' : '0' },
  }).then(response => {
    console.log('addAlbumFrom', response)
    return response
  })
}